import type { AccommodationHotelPolicyI18nFormModel } from "../../../../type";
import type { ServerModel } from "../../type";

type Props = {
	serverModel: ServerModel;
};

export const serverModelToInputModelConverter = ({
	serverModel,
}: Props): AccommodationHotelPolicyI18nFormModel["InputModel"] => {
	const { hotelPolicyI18n } = serverModel;

	if (!hotelPolicyI18n) {
		throw new Error("hotelPolicyI18n is null");
	}

	const viewModel: AccommodationHotelPolicyI18nFormModel["InputModel"] = {
		hotelInfo: hotelPolicyI18n.hotelInfo,
		id: hotelPolicyI18n.id,
		hotelID: hotelPolicyI18n.hotelID,
		lang: hotelPolicyI18n.lang,

		additionalFees: hotelPolicyI18n.additionalFees.map((item) => {
			return {
				additionalID: item.additionalID,
				billingTypeTarget: item.billingTypeTarget,
				billingTypeTerm: item.billingTypeTerm,
				billingTypeTermValidation: item.billingTypeTermValidation,
				isExcludeCancelFeeTarget: item.isExcludeCancelFeeTarget,
				isNotDiscountTarget: item.isNotDiscountTarget,
				isNotTargetOnDayTrip: item.isNotTargetOnDayTrip,
				kidsPrices: item.kidsPrices?.map((item) => {
					return {
						kidsMaxAge: item.kidsMaxAge,
						price: {
							amount: item.price.amount,
							currencyType: item.price.currencyType,
						},
					};
				}),
				name: item.name,
				price: item.price,
				termValidationApplyEndDt: item.termValidationApplyEndDt,
				termValidationApplyStartDt: item.termValidationApplyStartDt,
				useKidsPrice: item.useKidsPrice,
			};
		}),

		questions: hotelPolicyI18n.questions,
	} satisfies AccommodationHotelPolicyI18nFormModel["InputModel"];

	return viewModel;
};
